export var CHANGE_LOGIN_COMPONENT = "CHANGE_LOGIN_COMPONENT";
